var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 16,
  viewBox: "0 0 13 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.4 0A6.4 6.4 0 0 0 0 6.4c0 4.32 5.64 9.2 5.88 9.408a.8.8 0 0 0 1.04 0C7.2 15.6 12.8 10.72 12.8 6.4A6.4 6.4 0 0 0 6.4 0Zm0 14.12c-1.704-1.6-4.8-5.048-4.8-7.72a4.8 4.8 0 0 1 9.6 0c0 2.672-3.096 6.128-4.8 7.72Zm0-10.92a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4Zm0 4.8a1.6 1.6 0 1 1 0-3.2 1.6 1.6 0 0 1 0 3.2Z",
  fill: "currentColor"
})));
export default SvgMapMarker;